// extracted by mini-css-extract-plugin
export default {"link":"NotFoundPage_link__SHE4z"};